import { useState, useEffect } from 'react';
import axios from 'axios';
import { axiosApi } from '../../api/setupApi';

const useNISSubtotals = (year) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!year) return;

    const fetchSubtotals = async () => {
      setLoading(true);
      setError(null);

      try {
        const { data } = await axiosApi.get(`/nis/subtotal/${year}`);
        if (data && data.success) {
          setData(data.data);
        } else if (data) {
          setError(data.message || 'Failed to fetch subtotals');
        }
      } catch (err) {
        setError(err.message || 'Error fetching subtotals');
      } finally {
        setLoading(false);
      }
    };

    fetchSubtotals();
  }, [year]);

  return { data, loading, error };
};

export default useNISSubtotals;